import styled from 'styled-components';
import HoverScrollText from './HoverScrollText';

export const StyledProductCard = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 15px;
  background-color: white;
  border: 1px solid #e9ecef;
`;

export const ProductImage = styled.img`
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: contain;
  object-position: center;
  cursor: pointer;
  border-bottom: 1px solid #e9ecef;
  ${({ $isPlaceholder }) => ($isPlaceholder ? 'opacity: 0.3;' : '')};
`;

export const ProductInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 12px;
  flex: 1;
`;

export const ProductName = styled(HoverScrollText)`
  font-size: 16px;
  font-weight: bold;
  margin: 8px 0 4px;
`;

export const ProductPrice = styled.p`
  font-size: 14px;
  color: #333;
  margin: 0;
`;

export const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ActionsContainer = styled.div`
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-top: 6px;
  padding-bottom: 12px;
`;

export const StyledButton = styled.button`
  border-radius: 8px;
  border: none;
  padding: 6px 1rem;
  background-color: #be1622;
  color: white;
  cursor: pointer;
  font-size: 0.75rem;
  text-transform: uppercase;
  transition:
    background-color 0.3s,
    transform 0.2s,
    box-shadow 0.3s;

  &:hover {
    background-color: #a1131f;
    transform: scale(1.02);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(190, 22, 34, 0.5);
  }

  &:disabled {
    background-color: #ccc;
    color: #666;
    cursor: not-allowed;
    transform: none;
  }
`;
